import * as React from 'react';

// material-ui
import { Alert, Button, Fade, Grow, IconButton, Slide } from '@mui/material';
import MuiSnackbar from '@mui/material/Snackbar';

// assets
import CloseIcon from '@mui/icons-material/Close';

import { useDispatch, useSelector } from 'store';
import { closeSnackbar } from 'store/slices/snackbar';
import { closeBackdrop } from 'store/slices/backdrop';

// animation function
function TransitionSlideLeft(props) {
    return <Slide {...props} direction="left" />;
}

function TransitionSlideUp(props) {
    return <Slide {...props} direction="up" />;
}

function TransitionSlideRight(props) {
    return <Slide {...props} direction="right" />;
}

function TransitionSlideDown(props) {
    return <Slide {...props} direction="down" />;
}

function GrowTransition(props) {
    return <Grow {...props} />;
}

// animation options
const animation = {
    SlideLeft: TransitionSlideLeft,
    SlideUp: TransitionSlideUp,
    SlideRight: TransitionSlideRight,
    SlideDown: TransitionSlideDown,
    Grow: GrowTransition,
    Fade
};

// ==============================|| ERROR SNACKBAR ||============================== //

const ErrorSnackbar = () => {
    const dispatch = useDispatch();
    const campaign = useSelector((state) => state.campaign);
    const campaignDetail = useSelector((state) => state.campaignDetail);
    const creativeEdit = useSelector((state) => state.creativeEdit);
    const pkg = useSelector((state) => state.package);
    const profile = useSelector((state) => state.profile);
    const project = useSelector((state) => state.project);
    const savedResult = useSelector((state) => state.savedResult);
    const workplace = useSelector((state) => state.workplace);
    const workspace = useSelector((state) => state.workspace);
    const persona = useSelector((state) => state.persona);

    const [open, setOpen] = React.useState(false);
    const [message, setMessage] = React.useState('');

    React.useEffect(() => {
        let msg = 
        campaign.error?.message ||
        campaignDetail.error?.message ||
        creativeEdit.error?.message ||
        pkg.error?.message ||
        profile.error?.message ||
        project.error?.message ||
        savedResult.error?.message ||
        workplace.error?.message ||
        workspace.error?.message ||
        persona.error?.message;
        if(msg){
            setMessage(msg);
            setOpen(true);
            dispatch(closeBackdrop());
        }
    }, [campaign.error, campaignDetail.error, creativeEdit.error, pkg.error, profile.error, project.error, savedResult.error, workplace.error, workspace.error, persona.error]);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setMessage(null);
        setOpen(false);
    };

    return (
        <>
            <MuiSnackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                message={message}
                TransitionComponent={animation['Fade']}
                action={
                    <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose} sx={{ mt: 0.25 }}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                }
            />
        </>
    );
};

export default ErrorSnackbar;
